// Single source of truth for portfolio copy.
// Matches the Naukri Gulf profile and the UAE CV (updated 6 Oct 2026).

const phoneDigits = "919441829942";
const phoneDigits2 = "917989424984";
const whatsappText =
  "Hi Narendra, I came across your portfolio and would like to talk about a frontend lead role.";

export const profile = {
  name: "Varada Narendra",
  role: "Technical Lead",
  title: "Technical Lead and Lead Frontend Engineer",
  years: "10+ years",
  location: "Bangalore, India",
  availability: "Can join within 3 months",
  photo: "/varada-narendra.jpg",
  lead:
    "I lead frontend teams that ship fast, accessible enterprise platforms in React, Next.js and TypeScript, and I build the Node.js and PostgreSQL services behind them. Right now that means 20+ engineers at Eximietas Design, building for Zebra Technologies.",

  // Set to a file in /public (e.g. "/Varada_Narendra_CV.pdf") to show a Download CV button.
  cv: "/Varada_Narendra_Technical_Lead_Frontend_Engineer_UAE_CV.pdf",

  contact: {
    email: "narendran069@gmail.com",
    phone: "+91 94418 29942",
    phone2: "+91 79894 24984",
    phoneHref: `tel:+${phoneDigits}`,
    phone2Href: `tel:+${phoneDigits2}`,
    whatsapp: `https://wa.me/${phoneDigits}?text=${encodeURIComponent(whatsappText)}`,
    linkedin: "https://linkedin.com/in/narendravarada",
    github: "https://github.com/varadanarendra",
    website: "https://varadanarendra.in/",
  },

  facts: [
    { label: "Current role", value: "Technical Lead, Eximietas Design" },
    { label: "Experience", value: "10+ years frontend, 7 with React, 1 year backend" },
    { label: "Products delivered", value: "15+ across startup, mid-scale and enterprise" },
    { label: "Team", value: "Leads 20+ engineers, has mentored up to 25" },
    { label: "Domains", value: "Banking, fintech, payments, GenAI, Web3/crypto, e-commerce, IoT" },
    { label: "Notice period", value: "3 months, negotiable" },
    { label: "UAE relocation", value: "Ready to relocate immediately, open to Dubai, Abu Dhabi or anywhere in the UAE" },
    { label: "Visa", value: "Needs UAE employment visa sponsorship" },
    { label: "Certificate attestation", value: "Degree certificate attestation completed, ready for visa processing" },
    { label: "Interviews", value: "Video calls during UAE working hours" },
    { label: "Core stack", value: "React, Next.js, TypeScript, Node.js, PostgreSQL, AWS" },
  ],

  clients: [
    "Wells Fargo",
    "PwC",
    "Microsoft",
    "GE",
    "Zebra Technologies",
    "Capgemini",
    "Toshiba",
    "WadzPay",
    "TalusPay",
    "Cardinal Health",
    "Lamar",
    "Teleflora",
  ],

  results: [
    {
      value: "20%",
      label: "revenue growth contributed",
      detail: "Merchant and admin analytics on WadzPay's multi-token crypto platform",
    },
    {
      value: "95%",
      label: "automated test coverage",
      detail: "On the GenAI chatbot and real-time analytics platforms",
    },
    {
      value: "90%",
      label: "test coverage on web banking",
      detail: "Wells Fargo, with platform load times 15% faster",
    },
    {
      value: "30%",
      label: "faster application performance",
      detail: "Bundle optimisation and lazy loading on Zebra Technologies platforms",
    },
    {
      value: "30%",
      label: "higher team velocity",
      detail: "From a modular design system I architected at Elfonze",
    },
    {
      value: "40%",
      label: "fewer usability defects",
      detail: "WCAG 2.1 accessibility work for Teleflora, with CSAT up 15%",
    },
  ],

  featuredWork: [
    {
      client: "PwC, GE and Microsoft",
      via: "with Elfonze Technologies",
      title: "GenAI cloud-migration chatbot",
      summary:
        "Owned the HLD and LLD, prototyped the UX in Figma, and integrated LLM APIs with real-time WebSockets so migration teams get answers while they work.",
      impact: "95% automated test coverage",
      stack: "React, TypeScript, LLM APIs, WebSockets",
    },
    {
      client: "Wells Fargo",
      via: "Senior Software Engineer",
      title: "Web banking UI",
      summary:
        "Accessibility and consistency work across the banking UI, plus localization and time-zone conversion modules built from high-fidelity Figma designs.",
      impact: "90% test coverage, 15% faster load times",
      stack: "React, Jest, React Testing Library, WCAG",
    },
    {
      client: "WadzPay",
      via: "with Elfonze Technologies",
      title: "Multi-token crypto platform",
      summary:
        "Built the secure merchant and admin analytics for a multi-token digital payments platform.",
      impact: "Contributed to 20% revenue growth",
      stack: "React, merchant and admin analytics",
    },
    {
      client: "Zebra Technologies",
      via: "with Eximietas Design",
      title: "Enterprise web platforms",
      summary:
        "Architecting the React and Next.js platforms, setting engineering standards, and running weekly releases through CI/CD with a 20+ person team.",
      impact: "Performance up 30%, Lighthouse 96",
      stack: "React, Next.js, TypeScript, Node.js, PostgreSQL, AWS",
    },
  ],

  moreWork: [
    {
      client: "Talus Pay",
      title: "B2B point-of-sale system",
      impact: "Improved platform stability and engagement",
      stack: "React, TypeScript, Tailwind CSS",
    },
    {
      client: "Capgemini (Darden Restaurants)",
      title: "Real-time B2B admin dashboard",
      impact: "Decision-making visibility up 30%, 95% test coverage",
      stack: "React, Redux, Material UI, Chart.js, real-time analytics",
    },
    {
      client: "PwC, Cardinal Health and Lamar",
      title: "GenAI chatbot and analytics platform",
      impact: "95% test coverage with Jest and React Testing Library",
      stack: "React, Redux, Node.js, Express, PostgreSQL, MongoDB, WebSockets, Google Looker",
    },
    {
      client: "Teleflora",
      title: "E-commerce accessibility",
      impact: "40% fewer usability defects, CSAT up 15%",
      stack: "React, WCAG 2.1",
    },
    {
      client: "Toshiba",
      title: "EV charging IoT dashboards",
      impact: "Map-based real-time telemetry for charging stations",
      stack: "React, GraphQL, Leaflet, Google Maps",
    },
  ],

  // Paste LinkedIn recommendations here; the section appears once this has entries.
  // { quote: "...", name: "Full Name", role: "Their title, Company", relation: "Managed Narendra at ..." }
  testimonials: [],

  experience: [
    {
      role: "Technical Lead",
      company: "Eximietas Design",
      url: "https://eximietas.design/",
      start: "Dec 2025",
      end: "Present",
      summary:
        "Leading a cross-regional team of 20+ engineers delivering enterprise web platforms for Zebra Technologies.",
      points: [
        "Lead and coordinate 20+ professionals across multiple Business Units for Zebra Technologies USA as part of the Dominators leadership team",
        "Architect enterprise-grade platforms in React.js and Next.js and define the engineering standards the team builds to",
        "Improved application performance by 30% through bundle optimisation and lazy loading, taking Lighthouse from 74 to 96",
        "Turn business requirements into JIRA stories and run agile delivery with weekly releases through CI/CD",
        "Mentor engineers on scalable component architecture and code quality to keep technical debt down",
        "Build backend services and REST APIs with Node.js, Express and PostgreSQL, running on AWS core services",
      ],
      stack: "React.js, Next.js, TypeScript, Node.js, Express, PostgreSQL, MongoDB, AWS, CI/CD, JIRA",
    },
    {
      role: "UI Delivery Lead",
      company: "Elfonze Technologies",
      url: "https://www.elfonze.com/",
      start: "May 2022",
      end: "Nov 2025",
      summary:
        "Led a UI team of 4 delivering enterprise products for global clients, and standardised code review across client projects.",
      points: [
        "Engineered a GenAI cloud-migration chatbot for PwC, GE and Microsoft, owning HLD, LLD and Figma UX prototypes",
        "Integrated LLM APIs and real-time WebSockets for chatbot and analytics platforms with 95% test coverage",
        "Architected a modular design system that increased team velocity by 30%",
        "Built a real-time B2B admin dashboard for Capgemini, improving decision visibility by 30%",
        "Delivered a multi-token crypto platform for WadzPay that contributed to 20% revenue growth",
        "Led WCAG 2.1 accessibility for Teleflora: 40% fewer usability defects and 15% higher CSAT",
        "Delivered the Talus Pay B2B POS in React, TypeScript and Tailwind",
        "Built backend APIs with Node.js, Express, PostgreSQL and MongoDB as part of full-stack delivery",
        "Worked with product, design and backend teams across regions to ship responsive interfaces against business goals",
      ],
      stack: "React, TypeScript, Tailwind CSS, WebSockets, LLM APIs, Figma, Node.js, Express, PostgreSQL, MongoDB",
    },
    {
      role: "Senior Software Engineer",
      company: "Wells Fargo",
      url: "https://www.wellsfargo.com/",
      start: "Nov 2021",
      end: "May 2022",
      summary: "Worked on Wells Fargo web banking platforms in a distributed agile team.",
      points: [
        "Raised test coverage to 90% and improved platform load times by 15%",
        "Improved web banking UI accessibility and consistency in line with WCAG",
        "Built localization and time-zone conversion modules and high-fidelity components from Figma",
        "Mentored junior developers on advanced React design patterns",
        "Worked with multinational product and QA teams to refine requirements and cut UI technical debt",
      ],
      stack: "React, WCAG, Jest, React Testing Library, Figma",
    },
    {
      role: "Software Engineer",
      company: "Toshiba India",
      url: "https://toshiba-india.com/",
      start: "Jun 2020",
      end: "Oct 2021",
      summary: "Built real-time IoT platforms for EV charging infrastructure.",
      points: [
        "Developed real-time IoT dashboards with map-based telemetry for EV charging stations using Leaflet and Google Maps",
        "Designed a scalable frontend architecture with reusable React component patterns",
        "Integrated secure GraphQL and REST APIs for real-time device control with backend and hardware teams",
        "Led team-wide code reviews and mentored colleagues on frontend performance",
      ],
      stack: "React, GraphQL, REST APIs, Leaflet, Google Maps",
    },
    {
      role: "UI Developer",
      company: "Chipmonk Technologies",
      url: "https://chipmonk.in/",
      start: "Feb 2019",
      end: "Jun 2020",
      summary: "Built IoT-driven dashboards for smart-city infrastructure.",
      points: [
        "Engineered responsive IoT dashboards for smart-city infrastructure with JavaScript, React and Redux",
        "Implemented secure multi-role interfaces handling high-volume RESTful telemetry",
        "Partnered with UX designers on usability and visual consistency",
      ],
      stack: "JavaScript, React, Redux, REST APIs",
    },
    {
      role: "UI Developer and Web Designer",
      company: "Qupro Natural Therapeutics",
      url: "https://qupro.in/",
      start: "Jul 2015",
      end: "Dec 2018",
      summary: "Owned website design and e-commerce delivery end to end.",
      points: [
        "Delivered end-to-end e-commerce on OpenCart and WordPress with payment gateway and GST compliance",
        "Worked with the founder on product scaling, digital strategy and high-conversion checkout flows",
      ],
      stack: "OpenCart, WordPress, HTML, CSS, JavaScript, payment gateways",
    },
  ],

  // Years of hands-on use, from the Naukri Gulf profile.
  frontendYears: [
    { skill: "JavaScript", years: 10.25, text: "10 yrs" },
    { skill: "HTML and CSS", years: 10.5, text: "10 yrs" },
    { skill: "Redux", years: 7.67, text: "7 yrs 8 mos" },
    { skill: "React.js", years: 7, text: "7 yrs" },
    { skill: "REST APIs", years: 7, text: "7 yrs" },
    { skill: "GraphQL", years: 6.33, text: "6 yrs 4 mos" },
    { skill: "Jest", years: 4.92, text: "4 yrs 11 mos" },
    { skill: "TypeScript", years: 4.42, text: "4 yrs 5 mos" },
    { skill: "Tailwind CSS", years: 4.42, text: "4 yrs 5 mos" },
    { skill: "WebSockets", years: 4.42, text: "4 yrs 5 mos" },
  ],

  // About a year of backend work at Eximietas Design and Elfonze.
  // Trim the AWS list to the services you have used hands-on.
  backend: [
    {
      skill: "Node.js and Express",
      text: "1 yr",
      detail: "Backend services and REST APIs for enterprise platforms",
    },
    {
      skill: "PostgreSQL",
      text: "1 yr",
      detail: "Relational data behind those APIs, plus MongoDB and Supabase",
    },
    {
      skill: "AWS core services",
      text: "1 yr",
      detail: "EC2, S3, Lambda, RDS, IAM and CloudWatch",
    },
  ],

  skillGroups: [
    {
      name: "Frontend",
      items: "React.js, Next.js, TypeScript, JavaScript (ES6+), HTML5, CSS3, Redux, Zustand, Context API, TanStack Query, Tailwind CSS, Material UI, shadcn/ui, Storybook",
    },
    { name: "APIs and real-time", items: "REST, GraphQL, gRPC, WebSockets" },
    {
      name: "GenAI",
      items: "LLM API integration, generative AI chatbots, conversational AI workflows, AI-assisted development with Claude AI, GitHub Copilot and Figma AI",
    },
    { name: "Cloud and delivery", items: "AWS, GCP, Azure (working knowledge), GitLab CI/CD, Jenkins, Git, Vite, Webpack" },
    { name: "Quality and accessibility", items: "Jest, React Testing Library, Cypress, SonarQube, Lighthouse, WCAG 2.1" },
    { name: "Data visualisation and maps", items: "Chart.js, Google Looker, Leaflet, Google Maps" },
    {
      name: "Global products",
      items: "Localization, time-zone handling, multi-role access control",
    },
    {
      name: "Leadership",
      items: "Frontend architecture, team leadership, mentoring, Agile and Scrum, JIRA, sprint planning, EPIC grooming, stakeholder communication, performance optimisation",
    },
  ],

  certifications: [
    {
      name: "Claude: Master Claude Cowork, Claude Code, Skills and Plugins",
      provider: "Udemy",
      date: "Oct 2026",
      url: "https://ude.my/UC-dc28f827-32b7-4f80-b690-c6c706d10d92",
    },
    {
      name: "Ultimate AWS Certified Cloud Practitioner CLF-C02",
      provider: "Udemy, Stephane Maarek",
      date: "Aug 2026",
      url: "https://ude.my/UC-e67530a4-fc07-448a-96cc-9996f673164e",
    },
    {
      name: "NestJS Zero to Hero: Modern TypeScript Back-end Development",
      provider: "Udemy, Ariel Weinberger",
      date: "Jul 2026",
      url: "https://ude.my/UC-98d9d7ad-3d75-46fe-8c18-fa0483ff478a",
    },
  ],

  education: {
    degree: "B.Tech, Electrical and Electronics Engineering",
    institution: "Sri Venkateshwara College of Engineering, Andhra Pradesh",
    years: "2012 to 2015",
    note: "Certificate attestation completed, ready for UAE visa processing",
  },

  languages: "English, Telugu",
};
